module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aBeFf"))).then(() => parcelRequire('hEqeo'));